function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoUserTemplate = require('./saito-user.template');

// Shared canvas 2D context for measuring rendered text width without touching layout.
var measureCanvasCtx = null;
function getMeasureContext() {
  if (!measureCanvasCtx) {
    measureCanvasCtx = document.createElement('canvas').getContext('2d');
  }
  return measureCanvasCtx;
}
function getElementFont(el) {
  var style = window.getComputedStyle(el);
  return "".concat(style.fontStyle, " ").concat(style.fontVariant, " ").concat(style.fontWeight, " ").concat(style.fontSize, " ").concat(style.fontFamily);
}

// Finds the longest "prefix…suffix" truncation of `text` that fits within `maxWidth`
// (measured using el's font), falling back to the untruncated string if it already fits.
function truncateMiddleToFit(text, el, maxWidth) {
  var ctx = getMeasureContext();
  ctx.font = getElementFont(el);
  if (ctx.measureText(text).width <= maxWidth) {
    return text;
  }
  var ellipsis = '…';
  var lo = 1;
  var hi = Math.floor(text.length / 2);
  var best = 1;
  while (lo <= hi) {
    var mid = Math.floor((lo + hi) / 2);
    var candidate = "".concat(text.slice(0, mid)).concat(ellipsis).concat(text.slice(-mid));
    if (ctx.measureText(candidate).width <= maxWidth) {
      best = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }
  return "".concat(text.slice(0, best)).concat(ellipsis).concat(text.slice(-best));
}
var SaitoUser = /*#__PURE__*/function () {
  function SaitoUser(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var publicKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var notice = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var fourthelem = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    _classCallCheck(this, SaitoUser);
    this.app = app;
    this.mod = mod;
    this.publicKey = publicKey;
    this.notice = notice;
    this.fourthelem = fourthelem;
    this.container = container;
    this.extra_classes = '';
    this.data_disable = false; // prevent click to open user-menu
    this._addressResizeObserver = null;
  }
  return _createClass(SaitoUser, [{
    key: "updateUserline",
    value: function updateUserline(userline) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var qs = this.container + "> .saito-user-".concat(this.publicKey, " .saito-userline");
      var elem = document.querySelector(qs);
      if (elem) {
        elem.innerHTML = userline;
        if (userline) {
          elem.classList.remove('hidden');
        } else {
          elem.classList.add('hidden');
          elem.removeAttribute('title');
        }
        if (title) {
          elem.setAttribute('title', title);
        } else {
          elem.removeAttribute('title');
        }
      }
    }

    /**
     * Like updateUserline(), but for public keys/addresses: shows the full address
     * when there's room, otherwise a "prefix…suffix" truncation sized to the
     * userline element's actual rendered width. Re-measures on resize so it adapts
     * across breakpoints instead of using a fixed slice length.
     */
  }, {
    key: "updateUserlineAddress",
    value: function updateUserlineAddress() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var qs = this.container + "> .saito-user-".concat(this.publicKey, " .saito-userline");
      if (this._addressResizeObserver) {
        this._addressResizeObserver.disconnect();
        this._addressResizeObserver = null;
      }
      var paint = function paint() {
        var elem = document.querySelector(qs);
        if (!elem) {
          return;
        }
        if (!address) {
          elem.textContent = '';
          elem.classList.add('hidden');
          elem.removeAttribute('title');
          return;
        }
        var maxWidth = elem.clientWidth;
        elem.textContent = maxWidth ? truncateMiddleToFit(address, elem, maxWidth) : address;
        elem.classList.remove('hidden');
        elem.setAttribute('title', address);
      };
      paint();
      var elem = document.querySelector(qs);
      if (elem && typeof ResizeObserver !== 'undefined') {
        this._addressResizeObserver = new ResizeObserver(function () {
          return paint();
        });
        this._addressResizeObserver.observe(elem);
      }
    }
  }, {
    key: "updateAddress",
    value: function updateAddress(address) {
      var qs = this.container + "> .saito-user-".concat(this.publicKey, " .saito-address");
      if (document.querySelector(qs)) {
        document.querySelector(qs).innerHTML = address;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var qs = this.container + "> .saito-user-".concat(this.publicKey);
      if (document.querySelector(qs)) {
        this.app.browser.replaceElementBySelector(SaitoUserTemplate(this), qs);
      } else {
        this.app.browser.addElementToSelector(SaitoUserTemplate(this), this.container);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = SaitoUser;